const API = "https://jm.komerzy.com/backend/routes/api.php?url=ajusteinventarioapi";

export const getAjustes = async () => {
    const res = await fetch(`${API}&action=listar`);
    const data = await res.json();
    return data.data;
};

export const getProductosAjuste = async () => {
    const res = await fetch(`${API}&action=productos`);
    const data = await res.json();
    return data.data;
};

export const buscarProductos = async (q) => {
    const res = await fetch(`${API}&action=buscar&q=${q}`);
    const data = await res.json();
    return data.data;
};

// 🔥 DEBUG VERSION REAL
export const guardarAjuste = async (ajuste) => {

    const res = await fetch(`${API}&action=registrar`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(ajuste)
    });

    const text = await res.text();

    try {
        return JSON.parse(text);
    } catch (e) {
        return {
            status: "error",
            message: "Invalid JSON from server",
            raw: text
        };
    }
};